export const MODULE = 'MISCELLANEOUS_FEES';

export const CREATE = `${MODULE}/create_payment`;